export const detachBloggerGroupsModalName = 'detach-blogger-groups';
